<template>
	<div class="page newtongzhi" style="  display: flex;
  justify-content: space-between; margin: 0rem 0rem 2rem 0rem; background: #F1F1F1 ;">
		<div style='width: 100%; '>
			<el-col style='width: 50%; '>
				<div>
					<el-card shadow="never" style="height: 100%; margin:5px; ">
						<div style="height: 15px;" slot="header">
							<span class='biaotiming'>功能介绍</span>
							<a class="moremessage" @click="goHelp()" target="_blank">更多</a>
						</div>
						<div>

							<div style="margin-top: -20px" v-if="mdList[0]">
								<!-- <h3>{{ path }}</h3> header footer-->

								<ul v-for="item in mdList[0]" :key="item.id" class="default-view">
									<li class="link fontcss" @click="goto(item)">{{item.parentMenuName}} -
										{{item.menuName}} - {{ item.title }}
									</li>
								</ul>
							</div>


						</div>
					</el-card>
				</div>
			</el-col>


			<el-col style='width: 50%;'>
				<div>
					<el-card shadow="never" style="height: 100%; margin:5px">
						<div style="height: 15px;" slot="header" >
							<span class='biaotiming'>常见问题</span>
							<a class="moremessage" @click="goHelp()" target="_blank">更多</a>
						</div>
						<div>

							<div style="margin-top: -20px" v-if="mdList[1]">

								<ul v-for="item in mdList[1]" :key="item.id" class="default-view">
									<li class="link fontcss"  @click="goto(item)">{{item.parentMenuName}} -
										{{item.menuName}} - {{ item.title }}
									</li>
								</ul>
							</div>

						</div>
					</el-card>
				</div>
			</el-col>


		</div>
		<!--   <div class="" v-if="mdList[0]" style="display:inline-block;width: 50%; ">
      <h3>功能介绍</h3>
      <ul v-for="item in mdList[0]" :key="item.id" class="default-view">
        <li class="link" @click="goto(item)">{{item.parentMenuName}} - {{item.menuName}} - {{ item.title }}</li>
      </ul>
    </div>
    <div class="" v-if="mdList[1]" style="display:inline-block;width: 50%; ">
      <h3>常见问题</h3>
      <ul v-for="item in mdList[1]" :key="item.id" class="default-view">
        <li class="link" @click="goto(item)">{{item.parentMenuName}} - {{item.menuName}} - {{ item.title }}</li>
      </ul>
    </div> -->
		<!-- <h3>{{ path }}</h3> header footer-->
		<empty v-if="!mdList[0] && !mdList[1]"/>
	</div>
</template>

<script>
	import {
		ajax
	} from "@/network/request";
	import empty from "@/views/empty";
	export default {
		name: "MdListCollect",
		components: { empty },
		data() {
			return {
				mdList: [
					[],
					[]
				],
				title: "暂时没有内容，敬请期待~",
			};
		},

		created() {
			this.path = this.$route.params.menuName;
			this.getData(this.$route.params.menuName);
			this.$store.commit("setLinks", [
				this.$route.params.parentMenuName,
				this.$route.params.menuName,
			]);
		},
		methods: {
			goHelp() {
				window.open("http://help.89892528.com/")
			},
			getData(name) {
				this.$store.state.thisKey = this.$route.params.menuName;
				ajax({
					url: "/helper/getListOrderShowNum",
					method: "POST",
					baseURL: "/hehe",
					data: {
						menuName: name,
					},
				}).then((res) => {
					console.log(res);
					this.mdList = [
						[],
						[]
					];
					if (res.data == null || res.data.length == 0) {
						this.mdList.length = 0;
						// this.mdList.push(this.title);
					} else {
						for (let i of res.data) {
							if (i.type == "0" && this.mdList[0].length < 10) {
								this.mdList[0].push(i);

							} else if (i.type == "1" && this.mdList[1].length < 10) {
								this.mdList[1].push(i);
							}

						}
						if (res.data.length == 1) {
							// this.$store.commit('delLinks')
							this.goto(res.data[0]);
						}
					}
				});
			},
			/**
			 *
			 * 跳转详情
			 *
			 */
			goto(name) {
				console.log(name);
				if (name == this.title) {
					return;
				}

				window.open("http://help.89892528.com/doc/" + name.parentMenuName + "/" + name.menuName + "/" + name.id);

				// window.open("http://help.89892528.com/doc/"+name.parentMenuName+name.menuName+name.id)
				// this.$store.commit('addLinks',name.title)
				/* this.$router.push({
					name: "mid",
					params: {
						id: name.id,
						parentMenuName: name.parentMenuName,
						menuName: name.menuName,
					},
				}); */
				// this.$router.push({
				//   name: "Detail",
				//   params: {
				//     id: name.id,
				//   },
				// });
			},
		},
		beforeRouteUpdate(to, from, next) {
			this.path = to.params.menuName;
			this.getData(this.path);
			this.$store.commit("setLinks", [
				to.params.parentMenuName,
				to.params.menuName,
			]);
			this.$store.commit("setThisKey", to.params.menuName);
			next();
		},
	};
</script>

<style scoped lang="scss">
	.page {
		margin: 1rem 2rem 2rem 2rem;

		text-align: left;
		height: calc(100% - 3rem);
		h1 {
			font-size: 24px;
		}

		.default-view {
			padding-top: 1rem;
			font-size: 20px;
			// font-weight: 100;
			line-height: 2px;
		}

		.link {
			cursor: pointer;
		}

		.link:hover {
			color: rgb(64, 131, 255);
			text-decoration: underline;
		}

		.footer {
			margin-top: 1rem;
		}
	}

	.error {
		text-align: center;
		font-size: 42px;
		font-family: 400;
		color: cornflowerblue;
		display: flex;
		align-items: center;
	}


	.biaotiming {
		
		font-size: 16px;
		font-weight: bold;
		color: #002766;
	}

	.fontcss {
		margin-left: -39px;
		list-style: none;
		font-size: 14px;
		color: rgb(0, 39, 102);
	}

	.newtongzhi {
		height: auto;
		width: auto;
		background: #FFFFFF;
		box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.1);
		border-radius: 3px;
	}

	.el-card__body {
		padding: 0px;
	}

	.moremessage {
		float: right;
		text-align: center;
		font-size: 12px;
		color: #8C96B6;
		cursor: pointer;
	}


</style>
